import requests from "./httpServices";

export const getMeetingByName = (name) => {
  return requests.get(`/element/meeting-by-name?name=${name}`);
};

export const getMeetingRecordings = (roomId, page = 1, limit = 10) => {
  return requests.get(
    `/element/recordings?roomId=${roomId}&page=${page}&limit=${limit}`
  );
};

export const updateMeetingRecordingName = (data) => {
  return requests.post(`/element/update-recording-name`, data);
};

export const getMeetingRecordingById = (recordingId) => {
  return requests.get(`/element/recordings/${recordingId}`);
};

export const getJoiningToken = (body) => {
  return requests.post(`/element/meeting-token`, body);
};

export const getMeetingSession = (meetingId) => {
  return requests.get(`/element/meeting-session/${meetingId}`);
};

export const saveMeetingSession = (roomId) => {
  return requests.post(`/rooms/save-meeting-session`, { roomId });
};

export const getUserMeetingSession = () => {
  return requests.get(`/rooms/get-saved-session`);
};

export const getMeetingSessionById = (sessionId) => {
  return requests.get(`/rooms/get-saved-session-by-id/${sessionId}`);
};

export const sendFeedback = (data) => {
  return requests.post(`/rooms/send-meeting-feedback`, data);
};

export const updateCustomMeetingName = (data) => {
  return requests.post(`/rooms/update-custom-meeting-name`, data);
};

export const updateMeetingSessionName = (data) => {
  return requests.post(`/rooms/update-meeting-session-name`, data);
};

export const updateMeetingSessionSettings = (data) => {
  return requests.post(`/rooms/update-meeting-session-settings`, data);
};